/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Input, Button, Table, Row, message, Tooltip } from "antd";
import { useNavigate } from "react-router";
import {
  capitalise,
  capitaliseWithHyphen,
  capitalize,
  serialNum,
  convertDate,
} from "../../../utils";
import { camelCase } from "../../../utils";
import search_icon from "../../../assests/images/search-icon.svg";
import { ReactComponent as Copy_Icon } from "../../../assests/images/SVG/copy-icon.svg";
import urls from "../../../api/urls";
import API from "../../../api";
import { APIs, getPremiseId } from "../../../utils/worker";
import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";
import "./style.scss";
import Heading from "../../../components/Heading";
// import ConfirmationModal from "../InScan/confirmationModal";

const { GET_CP_IN_SCAN_LIST } = urls;
let premiseId = getPremiseId();

const InScanCP = () => {
  const [manifestedCp, SetManifestedCp] = useState([]);
  const navigate = useNavigate();
  const [scannedAwbs, setScannedAwbs] = useState([]);

  const [loading, setLoading] = useState(false);
  const [visible, setvisible] = useState(false);
  const [unScannedAwb, setUnscannedAwb] = useState(false);
  const [totalScanned, setTotalScanned] = useState({
    tableTotal: 0,
    scannedCount: 0,
  });
  const [showtoolTip, setShowtoolTip] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);

  useEffect(() => {
    // console.log(manifestedCp);
    let totalScanned = manifestedCp.filter((val) => {
      return (
        val.barcodeStatus === "DRS_GENERATED" ||
        val.barcodeStatus == "OUT_FOR_DELIVERY" ||
        val.barcodeStatus === "INSCANNED_AT_CP"
      );
    });
    setTotalScanned({
      tableTotal: manifestedCp.length,
      scannedCount: totalScanned?.length,
    });
  }, [manifestedCp]);

  const getTableData = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_CP_IN_SCAN_LIST +
        premiseId?.split("Bearer ")[1] +
        "?pageNum=0&pageSize=100"
    ).getWithUserNPremiseHeader();
    if (response.status) {
      setLoading(false);
      SetManifestedCp(
        response?.response?.data.sort(function (a, b) {
          return a.barcodeStatus !== "MANIFESTED_FOR_CP"
            ? 1
            : b.barcodeStatus !== "MANIFESTED_FOR_CP"
            ? -1
            : 0;
        })
      );
    } else {
      setLoading(false);
      message.error(response.response.data.message || "Network error");
    }
    // SetManifestedCp(mock);
  };

  let filterData = () => {
    const unique = [
      ...new Map(
        manifestedCp?.map((item) => [item["manifestId"], item])
      ).values(),
    ];

    let data = unique?.map((val) => {
      return { text: val.manifestId, value: val.manifestId };
    });

    return data;
  };

  function copyText(text) {
    setShowtoolTip(!showtoolTip);
    navigator.clipboard.writeText(text);
  }

  const handleSubmit = async () => {
    if (scannedAwbs.length == 0) {
      return navigate("/dashboard");
    }

    let barcodes = [...new Set(scannedAwbs)];
    let response = await API.Api(`${APIs.baseURL}/in-scan/v1`).postIdHeader({
      barcodes,
    });
    if (response.status) {
      setLoading(false);
      navigate("/dashboard");
      // handleStatus("/sort-shipment");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      // width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Awb No/Packet Id",
      dataIndex: "barcode",
      width: 200,
      key: "barcode",
      render: (text, val) => {
        return (
          <div className="d-flex">
            <div style={{ width: "170px" }}>
              <span style={{ marginRight: "15px" }}>{text}</span>
            </div>

            <Tooltip title={showtoolTip ? "Copied" : "Copy"}>
              <span
                style={{ marginRight: "10px" }}
                className="pointer"
                onClick={() => copyText(text)}
              >
                <Copy_Icon />
              </span>
            </Tooltip>

            {val.barcodeStatus !== "MANIFESTED_FOR_CP" && <Scan_check />}
          </div>
        );
      },
    },

    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      filters: filterData(),
      onFilter: (value, record) => record.manifestId === value,
      key: "manifestId",
      width: 150,
    },

    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap" }}>{convertDate(text)}</div>
      ),
    },

    {
      title: "Booking CP",
      dataIndex: "cpName",
      key: "cpName",
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },

    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   key: "type",
    //   render: (text) => <div>{capitalize(text)}</div>,
    // },

    // {
    //   title: "Weight",
    //   dataIndex: "totalweight",
    //   key: "totalweight",
    //   render: (text) => <div>{text + " KG"} </div>,
    // },

    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <div>{capitalize(text)}</div>,
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Status",
      dataIndex: "barcodeStatus",
      key: "barcodeStatus",
      // render: (text) => <div>{capitaliseWithHyphen(text)}</div>,In Scan
    },
  ];

  function closeSuccessModal(params) {
    setvisible(false);
  }

  function handleSuccessOk(params) {
    setvisible(false);
    handleSubmit();
  }

  function openModal() {
    // const notScanned =
    //   manifestedCp &&
    //   manifestedCp?.filter((manifest) => manifest?.status !== "INSCANNED");
    // if (notScanned?.length == 0) {
    //   handleSubmit();
    // } else {
    //   setUnscannedAwb(notScanned);
    //   setvisible(true);
    // }
    navigate("/last-mile-operations");
  }

  const onChange = (pagination, filters, sorter, extra) => {
    let totalScann = extra.currentDataSource.filter((val) => {
      return val.barcodeStatus !== "MANIFESTED_FOR_CP";
    });
    return setTotalScanned({
      tableTotal: extra.currentDataSource.length,
      scannedCount: totalScann?.length,
    });
  };

  const handleScan = async (id) => {
    setLoading(true);

    let geManifestId = manifestedCp?.find((val) => val?.barcode == id);

    let barcodes = {
      manifestId: geManifestId?.manifestId,
      awbNumbers: [id],
    };
    let response = await API.Api(
      `${APIs.baseURL}/v1/last-mile/in-scan`
    ).postIdHeader(barcodes);
    if (response.status) {
      setLoading(false);
      getTableData();
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };
  return (
    <div className="inscan-cp-container">
      <Heading
        title={"CP In-scan Shipments"}
        navigateForward={"/generate-drs"}
      />
      <div className="consolidated-manifest-cntr">
        <div className="header">
          <div className="right">
            <Input
              placeholder="Scan by AWB No/Packet Id"
              bordered
              style={{ borderRadius: "5px", height: "40px", minWidth: "250px" }}
              suffix={<img src={search_icon} />}
              onChange={(e) => {
                if (e.target.value.length > 6) {
                  handleScan(parseInt(e.target.value));
                }
              }}
            />
          </div>
          <p>
            Scanned shipments {totalScanned?.scannedCount}/
            {totalScanned?.tableTotal}
          </p>
        </div>
        {/* <Row> */}
        <Table
          columns={columns}
          dataSource={manifestedCp}
          scroll={{ x: 800, y: 1000 }}
          loading={loading}
          pagination={false}
          onChange={onChange}
        />
        {/* </Row> */}
      </div>
      <Row className="flex-end mt-2">
        <Button
          className="save-btn"
          style={{ textAlign: "end" }}
          onClick={openModal}
          // disabled={checkInScanned}
        >
          DONE
        </Button>
      </Row>
    </div>
  );
};

export default InScanCP;
